// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3HJxh","select":"Header_select__1Pv-F","clinic":"Header_clinic__1a5b9"};